import axios from "axios";


//const URL = "http://localhost:3001";
const URL = "http://cliente.serrana.agr.br:3001";

const api = axios.create({
    baseURL : URL,
    auth: {
        username: "WebBoletos",
        password: "p@ssw0rdA"
    }
});

export default api;